import { placeBounds, type PlaceResult } from '../services/PlaceSearchService';

/** Where to move the map for a picked place: fit an area to its extent, fly to a point. */
export type PlaceMapTarget =
  | { kind: 'bounds'; bounds: [[number, number], [number, number]] }
  | { kind: 'point'; center: [number, number]; zoom: number };

/** Zoom for a place with no extent — a peak, an address. */
export const POINT_PLACE_ZOOM = 15;

export function placeMapTarget(place: Pick<PlaceResult, 'bbox' | 'lat' | 'lon'>): PlaceMapTarget | null {
  const bounds = placeBounds(place);
  if (bounds) return { kind: 'bounds', bounds };
  if (Number.isFinite(place.lon) && Number.isFinite(place.lat)) {
    return { kind: 'point', center: [place.lon, place.lat], zoom: POINT_PLACE_ZOOM };
  }
  return null;
}

/** [lon, lat] of a mapbox-gl map's centre, or null when there is no map (yet). */
export function mapCentreFocus(map: { getCenter?: () => { lng: number; lat: number } } | null | undefined): [number, number] | null {
  try {
    const centre = map?.getCenter?.();
    return centre && Number.isFinite(centre.lng) && Number.isFinite(centre.lat) ? [centre.lng, centre.lat] : null;
  } catch {
    return null;
  }
}
